/* eslint-disable import/no-cycle */
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { components } from '@app/modules/fast-cadastro/components/fast-autocomplete/fast-autocomplete.component';
import { PrimeNGConfig } from 'primeng/api';
import { Table } from 'primeng/table';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import {
  COLUMN_DATA_TYPE,
  DeepPartial,
  EntityService,
  ErroMessages,
  IChipFilters,
  IErroMessages,
  IErrorResponse,
  ILabelValueSelect,
  ListItemOptions,
  TokenService
} from 'viggo-sistemas-core-web';
import { ConfirmDialogComponent, ConfirmDialogData, SELECT } from '..';
import { convertDateToMaskTimezone } from '../../utils/date';

const ordemIndex = (a: ILabelValueSelect, b: ILabelValueSelect) =>
  a.index > b.index ? 1 : -1;

export interface IColumnDefs {
  field: string;
  header_name: string;
  active: boolean;
  removable: boolean;
  group_by: boolean;
  isGroupBy: boolean;
  isTotalizer: boolean;
  total: boolean;
  type: COLUMN_DATA_TYPE;
  width?: string;
  widthReport?: string;
  decimalsReport?: number;
  flex?: number;
  cellRenderer?: (rowValue) => string;
  sortable?: boolean;
  field_sortable?: string;
  isInputValue?: boolean;
  isCheckboxValue?: boolean;
  labelCheckBox?: string;
}

export interface IFieldConfig {
  label: string;
  control: UntypedFormControl;
  class: string;
  display_search: string;
  type?: string;
  selectOptions?: SELECT[];
  selectedValue?: string;
  mask?: string;
  type_validation?: string; // ATUALMENTE APLICA UMA VALIDAÇÃO PARA FILTROS Q PODEM CONTER NUMEROS E LETRAS COMO O CODIGO DO PRODUTO QUE PODE SER UM SKU
}

export interface DialogSearchData {
  entityService: EntityService<any>;
  entityName: string;
  urlEntity: string;
  columnDefs: IColumnDefs[];
  title: string;
  fields: IFieldConfig[];
  useActiveEntityOnly?: boolean; // NAO APLICA FILTROS PARA QUALQUER STATUS APLICA SOMENTE PARA ATIVOS
  selectionObjectNotId?: boolean; // CASO ESTEJA COM O MULTIPLO ATIVO SELECIONA O OBJETO MARCADO E N SOMENTE O ID
  itensColumnDefs?: IColumnDefs[];
  keyEntityCompare?: string;
  keySubEntityCompare?: string;
  domain_path?: string;
  params_path?: string;
  params?: any;
  selectOnlyOne?: boolean;
  addBtn?: boolean;
  insertType?: any;
  include?: string[];
  order_by?: string[];
  entity_id?: string;
  useTableExpanded?: boolean;
  anotherDirectionType?: boolean; // usado para adicionar produtos e materias primas com ou sem variacao
  anotherDirectionType2?: boolean; // usado no adicionar pedidos da TPE
  anotherDirectionType3?: boolean; // usado no adicionar pedidos da expedicao
  anotherDirectionType4?: boolean; // usado no tpf_disponiveis do vendedor
  applyMultipleSelection?: boolean;
  useFilterChips?: boolean;
  subEntityName?: string;
  anotherDirection?: (
    value: string,
    objPagination: {
      require_pagination: boolean;
      page_size: number;
      page: number;
    },
    include?: string[],
    order_by?: string,
    domain_id?: string,
    other_params?: string,
    params?: any
  ) => Observable<any>; // GERALMENTE USADO PARA ROTAS ESPECIFICAS COMO O GET MODELOS/<ID>/MATERIAS_DISPONIVEIS
}

@Component({
  selector: 'dialog-search',
  templateUrl: 'dialog-search.component.html',
  styleUrls: ['./dialog-search.component.scss'],
  providers: [DatePipe]
})
export class DialogSearchComponent implements OnInit {
  entityService: any;
  dialogDataSearch = {} as DialogSearchData;
  pageLength = 0;
  page = 0;
  first = 0;
  rows = 0;
  page_size = 0;
  requisitions = 0;
  stateSearch = false;
  noResults = false;
  domain_path = 'domain_id';
  pageSizeOptions = [5, 10, 20, 50];
  data: any = {};
  maxDate = new Date();
  anotherDirection = null;
  dataSelection: any[] = [];
  dataItensSelection: any[] = [];
  filterOptionsChips: ILabelValueSelect[] = [];
  where: DeepPartial<unknown> = {};
  statusSelected = false;

  KEY_SUBENTITY_SELECTION = 'TEMP_SUBENTITIE_SELECTION';

  @ViewChild('tableExpanded') tableExpanded: Table;
  @ViewChild('tableEntitiesExpanded') tableEntitiesExpanded: Table;

  // USADA PARA COMPARAR OS ITENS DE UMA ENTITY SELECIONADOS
  keySubEntityCompare = 'variacao_id';

  // USADA PARA CHECAR SE A REFERENCIA QUE TEM NOS ITENS PERTENCE A ALGUMA DAS ENTITIES
  keyEntityCompare = 'id';

  idRowUnselect = '';

  subEntityName = 'data';

  searchValue: string | undefined;

  public entityName: string;
  protected entityURL: string;
  public KEY_DATA_SELECTION: string;
  public KEY_DATA_NOT_SELECTION: string;
  public KEY_DATA_ALL_SELECTED: string;
  public columnDefs: IColumnDefs[];
  public statusEntities: ListItemOptions = 'ACTIVE_ONLY';
  public filterEntities: any[];
  public entities: any[];
  public errorResponse: IErrorResponse;
  public loading = false;
  public moduleName: string;
  public previewType: 'GRID' | 'CARD' | string = 'GRID';

  constructor(
    protected router: Router,
    protected tokenService: TokenService,
    protected matDialogRef: MatDialogRef<DialogSearchComponent>,
    public datePipe: DatePipe,
    public dialog: MatDialog,
    public matSnackBar: MatSnackBar,
    private primengConfig: PrimeNGConfig,
    @Inject(MAT_DIALOG_DATA) data: DialogSearchData
  ) {
    this.entityName =
      data.entityName !== null && data.entityName !== undefined
        ? data.entityName
        : 'data';
    this.entityURL = data.urlEntity;
    this.KEY_DATA_NOT_SELECTION = `DATA_NOT_SELECTION_${data.entityName.toUpperCase()}_DIALOG_SEARCH`;
    this.KEY_DATA_SELECTION = `DATA_SELECTION_${data.entityName.toUpperCase()}_DIALOG_SEARCH`;
    this.KEY_DATA_ALL_SELECTED = `SELECTED_ALL_TABLE_${data.entityName.toUpperCase()}_DIALOG_SEARCH`;

    this.buildAndSetValues(data);
    localStorage.setItem(this.KEY_SUBENTITY_SELECTION, JSON.stringify([]));
    localStorage.setItem(this.KEY_DATA_SELECTION, JSON.stringify([]));
  }

  buildAndSetValues(data: DialogSearchData) {
    this.primengConfig.ripple = true;
    this.dialogDataSearch = data;
    this.entityService = data.entityService;
    this.columnDefs = data.columnDefs;
    if (data.subEntityName) this.subEntityName = data.subEntityName;
    if (data.anotherDirection) this.anotherDirection = data.anotherDirection;
    if (data.domain_path) this.domain_path = data.domain_path;
    if (data.keyEntityCompare) this.keyEntityCompare = data.keyEntityCompare;
    if (data.keySubEntityCompare)
      this.keySubEntityCompare = data.keySubEntityCompare;
    if (data.useFilterChips) this.overrideFilters();
  }

  overrideFilters() {
    var i = 0;
    this.dialogDataSearch.fields.forEach(it => {
      this.filterOptionsChips.push({
        label: it.label,
        value: it.display_search,
        index: i++,
        type:
          it.type === 'data_range'
            ? 'date'
            : it.type === 'text'
            ? 'string'
            : it.type,
        filterConfig: {
          placeholder: it.label,
          useDateMaskTimeZone: true,
          mask: it.mask,
          mode: it.type === 'data_range' ? 'range' : 'single',
          selectOptions: it.selectOptions
        }
      });
    });
  }

  public ngOnInit() {
    localStorage.setItem(
      this.KEY_DATA_SELECTION,
      JSON.stringify(this.dataSelection)
    );
    localStorage.setItem(this.KEY_DATA_NOT_SELECTION, JSON.stringify([]));
    localStorage.setItem(this.KEY_DATA_ALL_SELECTED, 'false');
    this.onLoad(0, false, true);
  }

  enterSearch(event) {
    if (event.key === 'Enter') {
      this.onSearch();
    }
  }

  public onClearKeyword(): void {
    this.stateSearch = false;
    this.noResults = false;
    this.statusSelected = false;
    this.statusEntities = 'ACTIVE_ONLY';
    this.dialogDataSearch.fields.forEach(keyword => {
      keyword.control.reset();
    });
    this.onLoad(0, false, true);
  }

  public reloadChips(chips: IChipFilters[]) {
    chips.forEach(it => {
      this.filterOptionsChips.push({
        label: this.getLabel(it.deepPartial),
        type: it.deepPartial.type,
        value: it.deepPartial.field,
        index: this.getIndex(it.deepPartial),
        filterConfig: it.deepPartial.filterConfig
      });
    });
    this.filterOptionsChips.sort(ordemIndex);
    this.onSearch(0, null, false, null, false, true);
  }

  public clearFilter(control: UntypedFormControl): void {
    // this.dialogDataSearch.fields.forEach(keyword => {
    //   if(keyword.type === 'status') keyword.control.reset();
    // });
    this.dialogDataSearch.fields.forEach(keyword => {
      if (keyword.control === control) {
        control.reset();
        const index = Object.keys(this.where).findIndex(
          key => key === keyword.display_search
        );
        if (index !== -1) {
          delete this.where[keyword.display_search];
        }
      }
    });
    this.onLoad(0, false, true);
  }

  onLoad(page = 0, reload?: boolean, notFirstReq?: boolean) {
    if (notFirstReq) this.requisitions = 0;
    this.requisitions += 1;
    if (this.requisitions === 1) {
      this.entities = [];
      this.filterEntities = [];
      this.loading = true;
      this.page = reload ? this.page : page;
      this.page_size = Number(localStorage.getItem('PAGINATOR_SIZE') || 5);

      if (this.stateSearch) this.onSearch(0, reload);
      else {
        var params = `page=${this.page}&page_size=${
          this.page_size
        }&list_options=${this.statusEntities}&${this.domain_path}=${
          this.tokenService.getDomain().id
        }`;

        if (this.dialogDataSearch.include)
          params += `&include=${this.dialogDataSearch.include}`;
        if (this.dialogDataSearch.order_by)
          params += `&order_by=${this.dialogDataSearch.order_by}`;
        if (this.dialogDataSearch.params_path)
          params += `&${this.dialogDataSearch.params_path}=${this.dialogDataSearch.params}`;

        const req = this.anotherDirection
          ? this.dialogDataSearch.anotherDirectionType
            ? this.anotherDirection(params, null, true, true)
            : this.dialogDataSearch.anotherDirectionType2
            ? this.anotherDirection(
                {
                  require_pagination: true,
                  page_size: this.page_size,
                  page: this.page
                },
                this.dialogDataSearch.include,
                this.tokenService.getDomain().id,
                this.dialogDataSearch.params,
                this.dialogDataSearch.order_by
              )
            : this.dialogDataSearch.anotherDirectionType3
            ? this.anotherDirection(
                this.dialogDataSearch.entity_id,
                params,
                null,
                true,
                true
              )
            : this.dialogDataSearch.anotherDirectionType4
            ? this.anotherDirection(
                this.dialogDataSearch.entity_id,
                {
                  require_pagination: true,
                  page_size: this.page_size,
                  page: this.page
                },
                this.dialogDataSearch.include,
                this.tokenService.getDomain().id,
                this.dialogDataSearch.params
              )
            : this.anotherDirection(
                this.dialogDataSearch.entity_id,
                {
                  require_pagination: true,
                  page_size: this.page_size,
                  page: this.page
                },
                this.dialogDataSearch.include,
                null,
                this.tokenService.getDomain().id,
                this.dialogDataSearch.params,
                null
              )
          : this.entityService.getEntitiesByParams(params, null, true);
        req
          .pipe(
            finalize(() => {
              this.loading = false;
            })
          )
          .subscribe(
            entities => {
              this.entities =
                this.dialogDataSearch.anotherDirectionType3 ||
                this.dialogDataSearch.anotherDirectionType4
                  ? entities[this.entityName][this.subEntityName]
                  : entities[this.entityName];
              this.page = entities.pagination.page;
              this.pageLength = entities.pagination.total;
            },
            (err: HttpErrorResponse) => {
              this.loading = false;
              this.errorResponse = {
                title: 'Erro detectado',
                message: err.message,
                status: err.status.toString(),
                statusError: err.statusText
              } as IErrorResponse;
              this.displayError(err, true);
            },
            () => {
              this.loading = false;
              this.filterEntities = this.entities;
              // this.updateDataSelection();
              this.filterEntities.length === 0
                ? (this.noResults = true)
                : (this.noResults = false);
            }
          );
      }
    }
  }

  onSearch(
    page = 0,
    where_fields?: any,
    reload?: boolean,
    filterValue?: {
      field: string;
      value: string;
      type: string;
      filterConfig: any;
    },
    clear?: boolean,
    clearAll?: boolean
  ): void {
    this.stateSearch = true;
    this.entities = [];
    this.filterEntities = [];
    this.loading = true;
    this.page = reload ? this.page : page;
    this.page_size = Number(localStorage.getItem('PAGINATOR_SIZE') || 5);
    var objParams = {} as any;
    if (this.dialogDataSearch.useFilterChips) {
      objParams = this.applyFilterChips(
        page,
        where_fields,
        reload,
        filterValue,
        clear,
        clearAll
      );
    } else {
      objParams = this.singleSearch(page);
    }
    if (this.dialogDataSearch.include)
      objParams = { ...objParams, include: this.dialogDataSearch.include };

    if (this.dialogDataSearch.order_by)
      objParams = { ...objParams, order_by: this.dialogDataSearch.order_by };

    if (this.dialogDataSearch.params_path)
      objParams[
        this.dialogDataSearch.params_path
      ] = this.dialogDataSearch.params;

    this.where[this.domain_path] = this.tokenService.getDomain().id;
    const req = this.anotherDirection
      ? this.dialogDataSearch.anotherDirectionType
        ? this.anotherDirection(objParams, null, true, true)
        : this.dialogDataSearch.anotherDirectionType2
        ? this.anotherDirection(
            {
              require_pagination: true,
              page_size: this.page_size,
              page: this.page
            },
            this.dialogDataSearch.include,
            this.tokenService.getDomain().id,
            this.dialogDataSearch.useFilterChips ? this.where : objParams.where,
            this.dialogDataSearch.order_by
          )
        : this.dialogDataSearch.anotherDirectionType3
        ? this.anotherDirection(
            this.dialogDataSearch.entity_id,
            objParams,
            null,
            true,
            true
          )
        : this.dialogDataSearch.anotherDirectionType4
        ? this.anotherDirection(
            this.dialogDataSearch.entity_id,
            {
              require_pagination: true,
              page_size: this.page_size,
              page: this.page
            },
            this.dialogDataSearch.include,
            this.tokenService.getDomain().id,
            this.dialogDataSearch.useFilterChips ? this.where : objParams.where
          )
        : this.anotherDirection(
            this.dialogDataSearch.entity_id,
            {
              require_pagination: true,
              page_size: this.page_size,
              page: this.page
            },
            this.dialogDataSearch.include,
            null,
            this.tokenService.getDomain().id,
            this.dialogDataSearch.params,
            this.dialogDataSearch.useFilterChips ? this.where : objParams.where
          )
      : this.entityService.getEntitiesByParams(objParams, null, true);

    req.subscribe(
      entities => {
        this.entities =
          this.dialogDataSearch.anotherDirectionType3 ||
          this.dialogDataSearch.anotherDirectionType4
            ? entities[this.entityName][this.subEntityName]
            : entities[this.entityName];
        this.page = entities.pagination.page;
        this.pageLength = entities.pagination.total;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        this.errorResponse = {
          title: 'Erro detectado',
          message: err.message,
          status: err.status.toString(),
          statusError: err.statusText
        } as IErrorResponse;
        this.displayError(err, true);
      },
      () => {
        this.loading = false;
        this.filterEntities = this.entities;
        // this.updateDataSelection();
        this.filterEntities.length === 0
          ? (this.noResults = true)
          : (this.noResults = false);
      }
    );
  }

  /**
   * Aplica a dinâmica de filtros por meio do componente chips
   * @param page
   * @param where_fields
   * @param reload
   * @param filterValue
   * @param clear
   * @param clearAll
   */
  applyFilterChips(
    page = 0,
    where_fields?: any,
    reload?: boolean,
    filterValue?: {
      field: string;
      value: string;
      type: string;
      filterConfig: any;
    },
    clear?: boolean,
    clearAll?: boolean
  ) {
    if (clear) {
      if (Object.keys(this.where).length === 0) {
        this.stateSearch = false;
        if (filterValue.type === 'status') {
          this.statusEntities = 'ACTIVE_ONLY';
          this.statusSelected = false;
          const index = this.filterOptionsChips.findIndex(
            it => it.type === 'status'
          );
          delete this.where[filterValue.field];
          if (index === -1) {
            this.filterOptionsChips.push({
              label: this.getLabel(filterValue),
              type: filterValue.type,
              value: filterValue.field,
              index: this.getIndex(filterValue),
              filterConfig: filterValue.filterConfig
            });
            this.filterOptionsChips.sort(ordemIndex);
          }
        }
      } else {
        Object.keys(this.where).forEach(parenKey => {
          Object.keys(filterValue).forEach(childKey => {
            if (
              parenKey === filterValue[childKey] &&
              filterValue[childKey] !== 'status' &&
              filterValue[childKey] !== 'data_hora' &&
              filterValue[childKey] !== 'classificacao'
            ) {
              if (!this.dialogDataSearch.useActiveEntityOnly) {
                if (Object.keys(this.where).length === 1) {
                  if (!this.statusSelected) this.statusEntities = 'ACTIVE_ONLY';
                } else {
                  if (!this.statusSelected)
                    this.statusEntities = 'ACTIVE_AND_INACTIVE';
                }
              }
              delete this.where[parenKey];
              this.filterOptionsChips.push({
                label: this.getLabel(filterValue),
                type: filterValue.type,
                value: filterValue.field,
                index: this.getIndex(filterValue),
                filterConfig: filterValue.filterConfig
              });
              this.filterOptionsChips.sort(ordemIndex);
            } else if (
              childKey === 'type' &&
              filterValue[childKey] === 'date'
            ) {
              if (!this.statusSelected) delete this.where['status'];
              delete this.where['de'];
              delete this.where['ate'];
              delete this.where['attribute'];
              const index = this.filterOptionsChips.findIndex(
                it => it.type === 'date'
              );
              if (index === -1) {
                this.filterOptionsChips.push({
                  label: this.getLabel(filterValue),
                  type: filterValue.type,
                  value: filterValue.field,
                  index: this.getIndex(filterValue),
                  filterConfig: filterValue.filterConfig
                });
                this.filterOptionsChips.sort(ordemIndex);
              }
            } else if (
              childKey === 'type' &&
              filterValue[childKey] === 'status'
            ) {
              this.statusSelected = false;

              if (!this.dialogDataSearch.useActiveEntityOnly) {
                if (Object.keys(this.where).length === 0) {
                  this.statusEntities = 'ACTIVE_ONLY';
                } else {
                  this.statusEntities = 'ACTIVE_AND_INACTIVE';
                }
              }
              delete this.where[filterValue.field];
              const index = this.filterOptionsChips.findIndex(
                it => it.type === 'status'
              );
              if (index === -1) {
                this.filterOptionsChips.push({
                  label: this.getLabel(filterValue),
                  type: filterValue.type,
                  value: filterValue.field,
                  index: this.getIndex(filterValue),
                  filterConfig: filterValue.filterConfig
                });
                this.filterOptionsChips.sort(ordemIndex);
              }
            } else if (
              childKey === 'type' &&
              filterValue[childKey] === 'select'
            ) {
              if (!this.dialogDataSearch.useActiveEntityOnly) {
                if (Object.keys(this.where).length === 1) {
                  if (!this.statusSelected) this.statusEntities = 'ACTIVE_ONLY';
                } else {
                  if (!this.statusSelected)
                    this.statusEntities = 'ACTIVE_AND_INACTIVE';
                }
              }
              delete this.where[filterValue.field];
              const index = this.filterOptionsChips.findIndex(
                it => it.type === 'select'
              );
              if (index === -1) {
                this.filterOptionsChips.push({
                  label: this.getLabel(filterValue),
                  type: filterValue.type,
                  value: filterValue.field,
                  index: this.getIndex(filterValue),
                  filterConfig: filterValue.filterConfig
                });
                this.filterOptionsChips.sort(ordemIndex);
              }
            }
          });
        });
      }
    }

    if (filterValue && !clear) {
      this.stateSearch = true;
      const index = this.filterOptionsChips.findIndex(
        op => op.value === filterValue.field
      );
      if (index >= 0) {
        this.filterOptionsChips.splice(index, 1);
        this.filterOptionsChips.sort(ordemIndex);
      }
      if (!this.statusSelected && !this.dialogDataSearch.useActiveEntityOnly)
        this.statusEntities = 'ACTIVE_AND_INACTIVE';
      if (filterValue.type === 'string') {
        this.where[filterValue.field] = filterValue.value + '%';
      } else if (filterValue.type === 'number') {
        this.where[filterValue.field] = Number(filterValue.value);
      } else if (filterValue.type === 'status') {
        this.statusSelected = true;
        this.statusEntities = this.dialogDataSearch.useActiveEntityOnly
          ? 'ACTIVE_ONLY'
          : (filterValue.value as ListItemOptions);
        this.where[filterValue.field] = filterValue.value;
      } else if (filterValue.type === 'date') {
        this.where['de'] = JSON.parse(filterValue.value).de;
        this.where['ate'] = JSON.parse(filterValue.value).ate;
        this.where['attribute'] = filterValue.field;
      } else if (filterValue.type === 'select') {
        this.where[filterValue.field] = filterValue.value;
      } else this.where[filterValue.field] = filterValue.value;
    }

    if (clearAll) {
      this.where = {};
      this.statusEntities = 'ACTIVE_ONLY';
    }

    if (this.dialogDataSearch.params_path)
      this.where[
        this.dialogDataSearch.params_path
      ] = this.dialogDataSearch.params;

    return {
      pagination: {
        page: page,
        page_size: this.page_size
      },
      list_options: this.statusEntities,
      where: this.where
    } as any;
  }

  /**
   * Aplica a lógica de filtros pelos controls especificos
   * @param page
   * @returns
   */
  singleSearch(page) {
    if (this.dialogDataSearch.params_path)
      this.where[
        this.dialogDataSearch.params_path
      ] = this.dialogDataSearch.params;

    this.dialogDataSearch.fields.forEach(keyword => {
      if (keyword.control.value !== '' && keyword.control.value !== null) {
        if (
          keyword.type_validation &&
          keyword.type_validation === 'number_text'
        ) {
          if (!Number.isNaN(Number(keyword.control.value))) {
            this.where[keyword.display_search] = keyword.control.value;
          } else {
            this.where[keyword.display_search] = keyword.control.value + '%';
          }
        } else {
          if (keyword.type && keyword.type === 'number')
            this.where[keyword.display_search] = keyword.control.value;
          else if (keyword.type && keyword.type === 'status')
            this.where[keyword.display_search] = keyword.control.value.value;
          else if (keyword.type && keyword.type === 'data') {
            var date = new Date(keyword.control.value);
            var dateString = `${date.getFullYear()}-${date.getUTCMonth() +
              1}-${date.getDate()}`;
            this.where[keyword.display_search] = dateString;
          } else if (keyword.type && keyword.type === 'data_range') {
            var dateInitial = new Date(keyword.control.value[0]);
            var dateEnd = new Date(keyword.control.value[1]);

            var dateInitialString = convertDateToMaskTimezone(
              `${dateInitial.getFullYear()}-${dateInitial.getUTCMonth() +
                1}-${dateInitial.getDate()}`
            );
            var dateEndString = convertDateToMaskTimezone(
              `${dateEnd.getFullYear()}-${dateEnd.getUTCMonth() +
                1}-${dateEnd.getDate()}`
            );
            this.where['de'] = dateInitialString;
            this.where['ate'] = dateEndString;
            this.where['attribute'] = keyword.display_search;
          } else
            this.where[keyword.display_search] = keyword.control.value + '%';
        }
      }
    });

    return {
      pagination: {
        page: page,
        page_size: this.page_size
      },
      list_options: this.statusEntities,
      where: this.where
    } as any;
  }

  openDialogFast(): void {
    if (this.dialogDataSearch.insertType) {
      this.dialog
        .open(components[this.dialogDataSearch.insertType].component, {
          ...components[this.dialogDataSearch.insertType].config,
          disableClose: true,
          panelClass: ['dialog-sem-padding'],
          position: {
            top: '50px'
          },
          data: {
            ...components[this.dialogDataSearch.insertType].config.data,
            ...this.data
          }
        })
        .afterClosed()
        .subscribe(componentEntity => {
          if (componentEntity) this.onLoad(0, false, true);
        });
    }
  }

  get disabledClear() {
    var disabled = 0;
    this.dialogDataSearch.fields.forEach(keyword => {
      if (!keyword.control.value) disabled += 1;
    });
    return disabled === this.dialogDataSearch.fields.length;
  }

  /**
   * Entidades selecionadas
   */
  get selectedEntities(): any[] {
    return this.dataSelection;
  }

  /**
   * Entidades selecionadas
   */
  get selectedItensEntities(): any[] {
    return this.dataItensSelection;
  }

  /**
   * A Função que resgata o evento de mudança de página
   */
  handlePage(event): void {
    // this.first = event.first;
    this.rows = event.rows;
    localStorage.setItem('PAGINATOR_SIZE', `${event.rows}`);
    if (this.stateSearch) this.onSearch(event.page);
    else this.onLoad(event.page, false, true);
  }

  /**
   * A Função que resgata o evento de mudança de página
   */
  handlePageTableExpanded(event): void {
    // this.first = event.first;
    this.rows = event.rows;
    localStorage.setItem('PAGINATOR_SIZE', `${event.rows}`);
    if (this.stateSearch) this.onSearch(event.page);
    else this.onLoad(event.page, false, true);
  }

  /**
   * Caso o entity (Pai) seja deselecionado tem que ser observado se existia
   * algum filho selecionado na segunda tabela
   * @param event
   */
  rowUnselect(event) {
    const selectedEntities = JSON.parse(
      localStorage.getItem(this.KEY_DATA_SELECTION)
    );
    const unSelectedEntities =
      JSON.parse(localStorage.getItem(this.KEY_DATA_NOT_SELECTION)) ?? [];
    const headerChexbox =
      localStorage.getItem(this.KEY_DATA_ALL_SELECTED) === 'true';
    if (selectedEntities && selectedEntities.length !== 0) {
      const index = selectedEntities.findIndex(it => it.id === event.data.id);
      if (index >= 0) {
        selectedEntities.splice(index, 1);
        localStorage.setItem(
          this.KEY_DATA_SELECTION,
          JSON.stringify(selectedEntities)
        );
        unSelectedEntities.push(event.data);
        localStorage.setItem(
          this.KEY_DATA_NOT_SELECTION,
          JSON.stringify(unSelectedEntities)
        );
        if (headerChexbox) {
          localStorage.setItem(this.KEY_DATA_ALL_SELECTED, 'false');
        }
      }
    }
    this.idRowUnselect = event.data.id;
    this.selectionEntities([], true);
  }

  /**
   * Caso o filho seja deselecionado o LS é atualizado
   * @param event
   */
  rowUnselectItem(event, entity) {
    var selectionEntities = JSON.parse(
      localStorage.getItem(this.KEY_DATA_SELECTION)
    );
    var selectionEntitiesTemp = JSON.parse(
      localStorage.getItem(this.KEY_SUBENTITY_SELECTION)
    );
    const index = selectionEntitiesTemp.findIndex(
      it => it[this.keyEntityCompare] === event.data.id
    );
    if (index >= 0) {
      if (selectionEntities && selectionEntities.length !== 0) {
        const index2 = selectionEntities.findIndex(
          it => it[this.keyEntityCompare] === entity[this.keyEntityCompare]
        );
        if (index2 >= 0) {
          selectionEntities.splice(index2, 1);
          this.dataSelection = selectionEntities;
        }
      }
      selectionEntitiesTemp.splice(index, 1);
    }
    localStorage.setItem(
      this.KEY_SUBENTITY_SELECTION,
      JSON.stringify(selectionEntitiesTemp)
    );
    localStorage.setItem(
      this.KEY_DATA_SELECTION,
      JSON.stringify(selectionEntities)
    );
  }

  /**
   * Pelos itens que o pai selecionou checo se o item ja tem no LS para atualizar corretamente
   * @param itens
   */
  updateLsItensPelaSelecaoDoPai(itens: any[]) {
    var selectionEntities = JSON.parse(
      localStorage.getItem(this.KEY_DATA_SELECTION)
    );
    var selectionEntitiesTemp = JSON.parse(
      localStorage.getItem(this.KEY_SUBENTITY_SELECTION)
    );
    if (itens.length !== 0) {
      var unselectedItens = [];
      selectionEntitiesTemp.forEach(it => {
        const itemFind = selectionEntities.find(
          it2 => it2[this.keyEntityCompare] === it[this.keySubEntityCompare]
        );
        if (itemFind) return;
        else {
          unselectedItens.push(it);
        }
      });
      if (unselectedItens.length !== 0) {
        selectionEntitiesTemp = selectionEntitiesTemp.filter(
          val => !unselectedItens.includes(val)
        );
      }
      itens.forEach(it => {
        const item = selectionEntitiesTemp.find(
          it2 => it[this.keyEntityCompare] === it2[this.keyEntityCompare]
        );
        if (!item) selectionEntitiesTemp.push(it);
      });
      localStorage.setItem(
        this.KEY_SUBENTITY_SELECTION,
        JSON.stringify(selectionEntitiesTemp)
      );
      this.dataItensSelection = selectionEntitiesTemp;
    } else {
      if (selectionEntities.length !== 0) {
        selectionEntities.forEach(select => {
          if (select.itens.length !== 0) {
            select.itens.forEach(it => {
              itens.push(it);
            });
          }
        });
      }
      this.dataSelection = selectionEntities;
      this.dataItensSelection = itens;
      localStorage.setItem(this.KEY_SUBENTITY_SELECTION, JSON.stringify(itens));
    }
  }

  /**
   * Caso use TableExpanded o pai que for selecionado o filho também será
   * se tiver filhos
   * @param event
   */
  selectionEntities(event: any, rowIsUnselect = false) {
    var itens = [];
    const data = new Array<any>(event.data);
    if (data.length !== 0 && !rowIsUnselect) {
      this.markEntitySelected(event);
      data.forEach(select => {
        if (select.itens.length !== 0) {
          select.itens.forEach(it => {
            itens.push(it);
          });
        }
      });
      if (this.tableEntitiesExpanded) {
        if (this.tableEntitiesExpanded.selection.length !== 0) {
          this.tableEntitiesExpanded.selection.forEach(it => {
            const index = itens.findIndex(
              m => m[this.keyEntityCompare] === it[this.keyEntityCompare]
            );
            if (index >= 0) return;
            else {
              itens.push(it);
            }
          });
        }
        this.tableEntitiesExpanded.selection = itens;
        this.dataItensSelection = this.tableEntitiesExpanded.selection;
        this.updateLsItensPelaSelecaoDoPai(itens);
      } else {
        this.dataItensSelection = itens;
        this.updateLsItensPelaSelecaoDoPai(itens);
      }
    } else if (this.tableEntitiesExpanded) {
      if (this.tableEntitiesExpanded.selection.length !== 0 && !rowIsUnselect)
        localStorage.setItem(
          'TEMP_ENTITIE_SELECTION',
          JSON.stringify(this.tableEntitiesExpanded.selection)
        );
      else if (
        this.tableEntitiesExpanded.selection.length !== 0 &&
        rowIsUnselect
      ) {
        this.tableEntitiesExpanded.selection.forEach(it => {
          if (it[this.keySubEntityCompare] !== this.idRowUnselect)
            itens.push(it);
        });
        this.idRowUnselect = '';
      } else {
        const selectionEntitiesTemp = JSON.parse(
          localStorage.getItem('TEMP_ENTITIE_SELECTION')
        );
        if (selectionEntitiesTemp && selectionEntitiesTemp.length !== 0) {
          selectionEntitiesTemp.forEach(it => {
            if (it[this.keySubEntityCompare] !== this.idRowUnselect)
              itens.push(it);
          });
        }
        this.idRowUnselect = '';
        localStorage.removeItem('TEMP_ENTITIE_SELECTION');
      }
      this.tableEntitiesExpanded.selection = itens;
      this.dataItensSelection = this.tableEntitiesExpanded.selection;
      this.updateLsItensPelaSelecaoDoPai(itens);
    } else {
      this.dataItensSelection = itens;
      this.updateLsItensPelaSelecaoDoPai(itens);
    }
  }

  markEntitySelected(event) {
    const data = new Array<any>(event.data);
    let itens = [];
    const selectedEntities = JSON.parse(
      localStorage.getItem(this.KEY_DATA_SELECTION)
    );
    const unSelectedEntities = JSON.parse(
      localStorage.getItem(this.KEY_DATA_NOT_SELECTION)
    );
    if (selectedEntities && selectedEntities.length !== 0)
      itens = selectedEntities;

    data.forEach(select => {
      const index = selectedEntities.findIndex(it => it.id === select.id);
      if (index >= 0) return;
      itens.push(select);
    });
    localStorage.setItem(this.KEY_DATA_SELECTION, JSON.stringify(itens));

    if (unSelectedEntities && unSelectedEntities.length !== 0) {
      itens.forEach(it => {
        const index = unSelectedEntities.findIndex(it2 => it.id === it2.id);
        if (index >= 0) {
          unSelectedEntities.splice(index, 1);
          localStorage.setItem(
            this.KEY_DATA_NOT_SELECTION,
            JSON.stringify(unSelectedEntities)
          );
        }
      });
    }

    if (itens.length === this.pageLength) {
      localStorage.setItem(this.KEY_DATA_ALL_SELECTED, 'true');
    }
  }

  headerItemCheckboxAction(event, entity) {
    var selectionEntities = JSON.parse(
      localStorage.getItem(this.KEY_DATA_SELECTION)
    ) as any[];
    var itensSelected = JSON.parse(
      localStorage.getItem(this.KEY_SUBENTITY_SELECTION)
    ) as any[];

    if (!event.checked) {
      if (selectionEntities && selectionEntities.length !== 0) {
        const index = selectionEntities.findIndex(
          it => it[this.keyEntityCompare] === entity[this.keyEntityCompare]
        );
        if (index >= 0) {
          selectionEntities.splice(index, 1);
          this.dataSelection = selectionEntities;
        }
      }
      itensSelected = itensSelected.filter(
        val => val[this.keySubEntityCompare] !== entity[this.keyEntityCompare]
      );
      localStorage.setItem(
        this.KEY_DATA_SELECTION,
        JSON.stringify(selectionEntities)
      );
      localStorage.setItem(
        this.KEY_SUBENTITY_SELECTION,
        JSON.stringify(itensSelected)
      );
    } else {
      let itens = [];
      if (event.checked) {
        if (itensSelected && itensSelected.length !== 0) {
          itens = itensSelected;

          this.dataItensSelection.forEach((select: any) => {
            const index = itensSelected.findIndex(
              it => it[this.keyEntityCompare] === select[this.keyEntityCompare]
            );
            if (index >= 0) return;
            itens.push(select);
          });
          if (selectionEntities && selectionEntities.length !== 0) {
            const index = selectionEntities.findIndex(
              it => it[this.keyEntityCompare] === entity[this.keyEntityCompare]
            );
            if (index === -1) {
              selectionEntities.push(entity);
              this.dataSelection = selectionEntities;
            }
          } else {
            selectionEntities.push(entity);
            this.dataSelection = selectionEntities;
          }
          localStorage.setItem(
            this.KEY_DATA_SELECTION,
            JSON.stringify(selectionEntities)
          );
          localStorage.setItem(
            this.KEY_SUBENTITY_SELECTION,
            JSON.stringify(itens)
          );
        } else {
          this.dataItensSelection.forEach((select: any) => {
            itens.push(select);
          });

          if (selectionEntities && selectionEntities.length !== 0) {
            const index = selectionEntities.findIndex(
              it => it[this.keyEntityCompare] === entity[this.keyEntityCompare]
            );
            if (index === -1) {
              selectionEntities.push(entity);
              this.dataSelection = selectionEntities;
            }
          } else {
            selectionEntities.push(entity);
            this.dataSelection = selectionEntities;
          }

          localStorage.setItem(
            this.KEY_DATA_SELECTION,
            JSON.stringify(selectionEntities)
          );
          localStorage.setItem(
            this.KEY_SUBENTITY_SELECTION,
            JSON.stringify(itens)
          );
        }
      } else if (itensSelected && itensSelected.length !== 0) {
        itens = itensSelected;

        entity.itens.forEach((select: any) => {
          const index = itensSelected.findIndex(it => it.id === select.id);
          if (index >= 0) itens.splice(index, 1);
          else itens.push(select);
        });

        if (selectionEntities && selectionEntities.length !== 0) {
          const index = selectionEntities.findIndex(
            it => it[this.keyEntityCompare] === entity[this.keyEntityCompare]
          );
          if (index === -1) {
            selectionEntities.push(entity);
            this.dataSelection = selectionEntities;
          }
        } else {
          selectionEntities.push(entity);
          this.dataSelection = selectionEntities;
        }
        localStorage.setItem(
          this.KEY_DATA_SELECTION,
          JSON.stringify(selectionEntities)
        );
        localStorage.setItem(
          this.KEY_SUBENTITY_SELECTION,
          JSON.stringify(itens)
        );
      }
    }
  }

  headerChecboxAction(event) {
    localStorage.setItem(this.KEY_DATA_ALL_SELECTED, event.checked);
    localStorage.setItem(this.KEY_DATA_NOT_SELECTION, JSON.stringify([]));

    if (!event.checked) {
      localStorage.setItem(this.KEY_DATA_SELECTION, JSON.stringify([]));
    } else {
      let itens = [];

      const selectedEntities = JSON.parse(
        localStorage.getItem(this.KEY_DATA_SELECTION)
      );
      if (event.checked) {
        if (selectedEntities && selectedEntities.length !== 0) {
          itens = selectedEntities;

          this.dataSelection.forEach((select: any) => {
            const index = selectedEntities.findIndex(it => it.id === select.id);
            if (index >= 0) return;
            itens.push(select);
          });

          localStorage.setItem(this.KEY_DATA_SELECTION, JSON.stringify(itens));
        } else {
          this.dataSelection.forEach((select: any) => {
            itens.push(select);
          });

          localStorage.setItem(this.KEY_DATA_SELECTION, JSON.stringify(itens));
        }
      } else if (selectedEntities && selectedEntities.length !== 0) {
        itens = selectedEntities;

        this.data.forEach((select: any) => {
          const index = selectedEntities.findIndex(it => it.id === select.id);
          if (index >= 0) itens.splice(index, 1);
          else itens.push(select);
        });

        localStorage.setItem(this.KEY_DATA_SELECTION, JSON.stringify(itens));
      }
    }
  }

  /**
   * Caso use TableExpanded se todos os filhos forem selecionados o pai também será
   * @param event
   */
  selectionItens(event: any, expanded?: boolean, entity?) {
    const entitiesSelecion = JSON.parse(
      localStorage.getItem(this.KEY_DATA_SELECTION)
    ) as any[];
    const selectionEntitiesTemp = JSON.parse(
      localStorage.getItem(this.KEY_SUBENTITY_SELECTION)
    ) as any[];
    if (expanded) {
      var itens = [];
      if (selectionEntitiesTemp) {
        itens = itens.concat(selectionEntitiesTemp);
      }
      this.dataItensSelection.forEach(it => {
        const item = itens.find(
          it2 => it[this.keySubEntityCompare] === it2[this.keySubEntityCompare]
        );
        if (!item) itens.push(it);
      });
      this.dataItensSelection = itens;
      localStorage.setItem(this.KEY_SUBENTITY_SELECTION, JSON.stringify(itens));
    } else {
      const itensSelectedEntity = this.dataItensSelection.filter(
        it => it[this.keySubEntityCompare] === entity[this.keyEntityCompare]
      );
      if (itensSelectedEntity.length === entity.itens.length) {
        entitiesSelecion.push(entity);
        localStorage.setItem(
          this.KEY_SUBENTITY_SELECTION,
          JSON.stringify(this.tableEntitiesExpanded.selection)
        );
        this.dataSelection = entitiesSelecion;
        localStorage.setItem(
          this.KEY_DATA_SELECTION,
          JSON.stringify(entitiesSelecion)
        );
      } else {
        const index = selectionEntitiesTemp.findIndex(
          it => it[this.keyEntityCompare] === event.data[this.keyEntityCompare]
        );
        if (index === -1) {
          selectionEntitiesTemp.push(event.data);
        }
        localStorage.setItem(
          this.KEY_SUBENTITY_SELECTION,
          JSON.stringify(selectionEntitiesTemp)
        );
      }
    }
  }

  confirmSelection() {
    const selectedList = JSON.parse(
      localStorage.getItem(this.KEY_DATA_SELECTION)
    );
    if (this.dialogDataSearch.selectOnlyOne)
      this.matDialogRef.close(selectedList[0]);
    else if (
      !this.dialogDataSearch.selectOnlyOne &&
      this.dialogDataSearch.applyMultipleSelection
    )
      this.matDialogRef.close(this.getObjectData());
    else this.matDialogRef.close(selectedList);
  }

  disableSelection() {
    const selectedList = JSON.parse(
      localStorage.getItem(this.KEY_DATA_SELECTION)
    );
    if (this.dialogDataSearch.selectOnlyOne)
      return !(selectedList.length === 1);
    else return !(selectedList.length !== 0);
  }

  public onChangeStatus(newStatus: ListItemOptions) {
    if (newStatus === this.statusEntities) return;
    this.statusEntities = newStatus;
    this.statusSelected = !this.statusSelected;
    this.onLoad(0, false);
  }

  public changePreviewType(type: 'GRID' | 'CARD') {
    if (type !== this.previewType) {
      this.previewType = type;
      this.onLoad(0, false);
    }
  }

  getObjectData() {
    const allSelected =
      localStorage.getItem(this.KEY_DATA_ALL_SELECTED) === 'true';
    const selectedList = JSON.parse(
      localStorage.getItem(this.KEY_DATA_SELECTION)
    );
    const unSelectedList = JSON.parse(
      localStorage.getItem(this.KEY_DATA_NOT_SELECTION)
    );
    return {
      multiple_selection: {
        selected_list: allSelected
          ? []
          : this.dialogDataSearch.selectionObjectNotId
          ? selectedList
          : selectedList.map(it => it.id),
        unselected_list: this.dialogDataSearch.selectionObjectNotId
          ? unSelectedList
          : unSelectedList.map(it => it.id)
      },
      list_options: this.statusEntities,
      ...this.where
    };
  }

  getLabel(filterValue) {
    return this.dialogDataSearch.fields.find(
      it => filterValue.field === it.display_search
    ).label;
  }

  getIndex(filterValue) {
    return this.dialogDataSearch.fields.findIndex(
      it => filterValue.field === it.display_search
    );
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.dialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            bodyMessage: txtMsg,
            icon: 'pi pi-fw pi-info-circle text-orange-500 mb-2 mr-2',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.showMessageObject(txtMsg);
    // errorMsg.checkError();
  }

  getMessageError() {
    if (!this.errorResponse) return '';
    return `Identificamos o erro ${this.errorResponse.status} - ${this.errorResponse.statusError} no processamento dos dados!`;
  }

  getFirstConfigPagination(){
    return this.page * (Number(localStorage.getItem('PAGINATOR_SIZE') || 5));
  }
}
